import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x.svg'


const _hoisted_1 = {
  key: 0,
  class: "justify-center items-center flex bg-overlay fixed inset-0 z-50"
}
const _hoisted_2 = {
  class: "bg-white px-2 pb-2 justify-center items-center flex flex-col rounded-lg",
  style: {"width":"65%","height":"85%"}
}
const _hoisted_3 = { class: "w-full flex flex-row justify-between p-2" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "text-14px font-bold text-gray-lp-300" }, " Payment Point Online Banking ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.modelValue)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode("img", {
              src: _imports_0,
              class: "w-6 cursor-pointer",
              style: {"top":"1.5rem","right":"1.5rem"},
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.forceCloseDialog && _ctx.forceCloseDialog(...args))),
              alt: "ppob-image"
            })
          ]),
          _createVNode("iframe", {
            src: _ctx.urlPPOB,
            width: "100%",
            height: "100%",
            title: "ppob-modal"
          }, "\n        <p>Your browser does not support iframes.</p>\n      ", 8, ["src"])
        ])
      ]))
    : _createCommentVNode("", true)
}